import React, { useState, useEffect } from "react";
import TableWithSkeleton from '../../components/global/table/TableWithSkeleton'
import Pagination from '../../components/global/pagination/Pagination'
import columns from "../../columns/MT5Account/Demo";
import moment from "moment";
import { Spin } from 'antd';
import { GetAllDemoAccountApi } from "../../api/request/account";
import UserAvatar from "../../components/global/avtar/UserAvatar";

const DemoAccouts = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [sorter, setSorter] = useState({ SortBy: 'actionDate', SortOrder: '' });

    const getAllDemo = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllDemoAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            userDetails: ( <UserAvatar data={{ name: item?.name, email: item?.email, profileImage: item?.profileImage, }} /> ),
                            balance: `$ ${item?.balance}`,
                            createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }
    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'actionDate', SortOrder: '' });
        }
    };
    useEffect(() => {
        getAllDemo();
    }, [page, pageSize, filter, sorter]);

    useEffect(() => {
        setPage(1);
    }, []);

    return (
        <>
            <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <div className="px-4 lg:px-6">
                    <p className="text-[#2F2B3D] text-xl font-semibold">
                        Demo Accounts <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${totalRecord})`}</span>
                    </p>
                </div>
                <div className="my-6">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>
        </>
    )
}

export default DemoAccouts